<template>
  <div>
    
    <!-- Modal Nueva Operación -->
    <div class="modal fade" id="modalOperacion" tabindex="-1" aria-labelledby="modalOperacionLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fs-5" id="modalOperacionLabel">Nueva Operación</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              @click="limpiarOperacion()"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form action="" id="formOperacion" @submit.prevent="agregarFormaDePago()" enctype="multipart/form-data">
            <div class="modal-body" v-if="!motivoSelected">
              <div class="row" >
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="">Tipo de Pago</label>
                    <select class="form-control" v-model="operacion.tipo_pago">
                      <option value="CONTADO">Venta Contado</option>
                      <option value="CREDITO">Venta Crédito</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-body" v-else>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="">Documento</label>
                      <input class="form-control" ref="documento" id="documento" name="documento" type="file" accept="application/pdf">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="">Fecha operación</label>
                      <input class="form-control" type="date" v-model="operacion.fecha">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="">Hora operación</label>
                      <input class="form-control" type="time" v-model="operacion.hora">
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="">Referencia</label>
                      <input type="text" class="form-control" v-model="operacion.referencia" placeholder="Referencia">
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="">Comentario</label>
                      <textarea class="form-control" v-model="operacion.comentario"
                        cols="30" rows="5"></textarea>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="">Tipo de Operación</label>
                      <select class="form-control" v-model="operacion.tipo">
                        <option value="O">Operación</option>
                        <option value="F">Faltante</option>
                        <option value="S">Sobrante</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="">Forma de Pago</label>
                      <select class="form-control" v-model="operacion.forma_pago" @change="refreshCuentasBancos()">
                        <option value="EFECTIVO">EFECTIVO</option>
                        <option value="TARJETA_CREDITO">TARJETA DE CREDITO</option>
                        <option value="CERT">CERT</option>
                        <option value="CHEQUE">CHEQUE</option>
                        <option value="DEPOSITO">DEPOSITO BANCARIO</option>
                        <option value="DEVEFEC">DEVOLUCION DE EFECTIVO</option>
                        <option value="NC">NOTA DE CREDITO</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12" v-if="operacion.forma_pago === 'CHEQUE'">
                    <div class="form-group">
                      <input type="checkbox" class="form-control" v-model="operacion.es_prefechado">
                      <label for="">¿Es Prefechado?</label>
                    </div>
                  </div>
                  <div class="col-sm-12" v-if="operacion.forma_pago != 'NC'">
                    <div class="form-group">
                      <label for="">Banco</label>
                      <select class="form-control" v-model="operacion.banco"  @change="selectedBanco(operacion.banco)">
                        <option v-for="banco in bancos" :value="banco.id" :key="banco.id">{{ banco.nombre }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12" v-if="operacion.forma_pago != 'NC'">
                    <div class="form-group">
                      <label for="">Cuentas Bancarias</label>
                      <select class="form-control" v-model="operacion.cuenta_bancaria">
                        <option v-for="cuenta_bancaria in cuentas_bancarias" :value="cuenta_bancaria.id"
                          :key="cuenta_bancaria.id">
                          {{cuenta_bancaria.id }} - {{ cuenta_bancaria.nombre }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12" v-if="operacion.forma_pago === 'TARJETA_CREDITO'">
                    <div class="form-group">
                      <label for="">Terminal POS</label>
                      <select class="form-control" v-model="operacion.terminal">
                        <option v-for="terminal in terminales" :value="terminal.id" :key="terminal.id">{{ terminal.terminal }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="">Total</label>
                      <input class="form-control" v-model="operacion.total" placeholder="Total" type="number"
                        step=".01" min="0">
                    </div>
                  </div>
                </div>
            </div>
            <div class="modal-footer" v-if="!motivoSelected">
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="motivoSelected = true"
              >
                Siguiente
              </button>
            </div>
            <div class="modal-footer" v-else>
              <button
                type="submit"
                class="btn btn-primary"
              >
                Agregar
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                @click.prevent="motivoSelected = false"
              >
                Regresar
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                @click="limpiarOperacion()"
              >
                Cerrar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Fin de Modal Nueva Operación -->
  </div>
</template>
<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
export default {
  props:{
      current:{
        type: Object,
        default: () => ({}),
      },
      tienda:{
        type: String,
        default: '',
      },
      currentFullDate:{
        type: String,
        default: ''
      },
      totalVentas:{
        type: Number,
        default: 0
      },
      totalDetalles:{
        type: Number,
        default: 0
      }
    },
  data() {
    return {
      motivoSelected:false,
      operacion: {
        tipo_pago:"CONTADO",
        tipo: "O",
        fecha:"",
        hora:"",
        fecha_operacion: "",
        referencia: "",
        comentario: "",
        banco: null,
        cuenta_bancaria: null,
        forma_pago: "EFECTIVO",
        total: 0,
        documento: null,
        terminal:null,
        terminal_obj:null,
        es_prefechado:false,
      },
      terminales: [],
      bancos:null,
      cuentas_bancarias:null,
    };
  },
  computed:{
    motivoSelectedComputed(){
      return this.motivoSelected;
    },
    terminal_id(){
      return this.operacion.terminal
    },
    banco_operacion(){
      return this.operacion.banco;
    },
    referencia_operacion(){
      return this.operacion.referencia;
    },
    numero_afiliacion(){
      let terminal = ""
      if (this.operacion.terminal){
        terminal = this.terminales.find(terminal => terminal.id === this.operacion.terminal)
        return terminal.afiliacion;
      }
      return null;
    },
    tipo_pago(){
      return this.operacion.tipo_pago;
    }
  },
  watch:{
    referencia_operacion(newValue){
      if(newValue){
        this.generateCometario();
      }
    },
    banco_operacion(newValue){
      if(newValue){
        this.generateCometario();
      }
    },
    terminal_id(newValue){
      if(newValue){
        this.generateCometario();
      }
    },
  },
  mounted() {
    this.refreshCuentasBancos();
  },
  methods: {
    motivoToOperacion(){ // No se utiliza
      $("#modalOperacion").modal("hide");
      $("#modalOperacion2").modal("show");
    },
    operacionToMotivo(){ // No se utiliza
      $("#modalOperacion2").modal("hide");
      $("#modalOperacion").modal("show");
    },
    tipoOperacion(tipo){
      if(tipo === "O"){
        return "Operación";
      }else if(tipo === "F"){
        return "Faltante";
      }else if(tipo === "S"){
        return "Sobrante";
      }
    },
    agregarFormaDePago() {
      let self = this;
      const formData = new FormData();
      formData.append('total_ventas', self.totalVentas);
      formData.append('total_detalles', self.totalDetalles);
      let fecha_hora = `${self.operacion.fecha} ${self.operacion.hora}`;
      self.operacion.fecha_operacion = moment(fecha_hora).format("YYYY-MM-DD HH:mm:ss");
      if (self.$refs.documento.files.length > 0) {
        self.operacion.documento = self.$refs.documento.files[0];
        formData.append('documento', self.operacion.documento);
      }
      formData.append('banco', self.operacion.banco);
      formData.append('cuenta_bancaria', self.operacion.cuenta_bancaria);
      if(self.operacion.forma_pago === 'TARJETA_CREDITO'){
        if(self.operacion.terminal){
          formData.append('terminal', self.operacion.terminal);
        }else{
          self.$toast.error("Debe seleccionar un terminal para la tarjeta de crédito.","Error",{position: 'topRight'});
          return;
        }
      }else if(self.operacion.forma_pago === 'CHEQUE'){
        formData.append('es_prefechado', self.operacion.es_prefechado);
      }else if(self.operacion.forma_pago === 'NC'){
        formData.delete('banco', self.operacion.banco);
        formData.delete('cuenta_bancaria', self.operacion.cuenta_bancaria);
      }

      formData.append('fecha_operacion', self.operacion.fecha_operacion);
      formData.append('referencia', self.operacion.referencia);
      formData.append('comentario', self.operacion.comentario);
      formData.append('forma_pago', self.operacion.forma_pago);
      formData.append('total', self.operacion.total);
      formData.append('tipo', self.operacion.tipo);
      formData.append('tipo_pago', self.operacion.tipo_pago);
      console.log(self.operacion);
      DynamicService.postAction(
        "cxc",
        "corte-caja-tienda",
        self.current.id,
        'agregar_forma_pago',
        formData
      ).then((response) => {
        self.limpiarOperacion();
        $("#modalOperacion").modal("hide");
        this.$emit('refreshCorte');
        Notifications.alert.success(
          "Corte de Tienda",
          "Se agregó el detalle de la forma de pago correctamente."
        );
      })
      .catch((errors) => {
        if (errors.response) {
          Notifications.alert.error(
            "Corte de Tienda",
            JSON.stringify(errors.response.data)
          );
        }
      });
    },
    limpiarOperacion(){
      let self = this;
      self.operacion.fecha = "";
      self.operacion.tipo_pago = "CONTADO";
      self.operacion.hora = "";
      self.operacion.fecha_operacion = "";
      self.operacion.referencia = "";
      self.operacion.comentario = "";
      self.operacion.banco = null;
      self.operacion.cuenta_bancaria = null;
      self.operacion.forma_pago= "EFECTIVO";
      self.operacion.total = 0;
      self.$refs.documento.value = null;
      self.operacion.documento = null;
      self.operacion.terminal = null;
      self.operacion.terminal_obj = null;
      self.operacion.es_prefechado = false;
      self.motivoSelected = false;
      $("#modalOperacion").modal("hide");
    },
    generateCometario(){
      let self = this;

      if(self.operacion.forma_pago === 'EFECTIVO'){
        self.operacion.comentario = `Depósito ${self.banco_operacion}(${self.referencia_operacion}) Por Corte de Tienda ${self.current.tienda} de fecha ${self.currentFullDate}`
      }else if (self.operacion.forma_pago === 'TARJETA_CREDITO'){
        self.operacion.comentario = `AFI(${self.operacion.terminal_obj.afiliacion}), ${self.banco_operacion}(${self.referencia_operacion}) Por Corte de Tienda ${self.current.tienda} de fecha ${self.currentFullDate}`
      }else if (self.operacion.forma_pago === 'DEPOSITO'){
        self.operacion.comentario = `${self.banco_operacion}(${self.referencia_operacion}) Por Corte de Tienda ${self.current.tienda} de fecha ${self.currentFullDate}`
      }else if (self.operacion.forma_pago === 'CHEQUE'){
        self.operacion.comentario = `${self.operacion.banco}(${self.referencia_operacion}) Por Corte de Tienda ${self.current.tienda} de fecha ${self.currentFullDate}`
      }else if (self.operacion.forma_pago === 'NC'){
        self.operacion.comentario = `Nota de Crédito(${self.referencia_operacion}) Por Corte de Tienda ${self.current.tienda} de fecha ${self.currentFullDate}`
      }
    },
    selectedBanco(banco_id) {
      let self = this;
      let banco = self.bancos.find((banco) => banco.id === banco_id);
      if(banco.cuentas_bancarias.length === 0){
        self.$toast.error('No hay cuentas asociadas a este banco.',"Error",{position: 'topRight'});
        self.cuentas_bancarias = null;
        return;
      }
      self.cuentas_bancarias = banco.cuentas_bancarias;
      self.operacion.cuenta_bancaria = self.cuentas_bancarias[0].id;
    },
    refreshTerminales(){
      let self = this;
      DynamicService.postActionList('cxc', 'terminal-pos-caja','lista_terminales', { tienda:this.tienda })
      .then((response) => {
        self.terminales = response.data;
        if(self.terminales && self.terminales.length > 0){
          self.operacion.terminal_obj = self.terminales[0];
          self.operacion.terminal = self.terminales[0].id;
        }
      })
    },
    refreshCuentasBancos(){
      let self = this;
      self.refreshTerminales();
      self.generateCometario();
      if (self.operacion.forma_pago === 'NC'){
        return;
      }
      let params = { 
        quitar_paginacion: true,
        forma_pago:self.operacion.forma_pago,
        tipo: "I"
      }
      DynamicService.postActionList('cat', 'formas-pago-cuentas-bancarias','listar_bancos_cuentas_bancarias', params)
      .then((response) => {
        self.bancos = response.data;
        if (self.bancos.length === 0) {
          this.$toast.warning(
            'No hay bancos ni cuentas asociadas a esta forma de pago.',
            'Aviso',
            { position: 'topRight' }
          );
          return;
        }
        self.operacion.banco = self.bancos[0].id;
        if (self.bancos[0].cuentas_bancarias.length === 0){
          self.$toast.error('No hay cuentas asociadas a este banco.',"Error",{position: 'topRight'});
          return;
        }
        self.cuentas_bancarias = self.bancos[0].cuentas_bancarias;
        self.operacion.cuenta_bancaria = self.cuentas_bancarias[0].id;
      })
      .catch((error) => {
        if (error.response){
          console.error(error.response.data);
          self.$toast.error(JSON.stringify(error.response.data),"Error",{position: 'topRight'});
          self.bancos = null;
          self.cuentas_bancarias = null;
          self.operacion.banco = "";
          self.operacion.cuenta_bancaria = "";
        }
      });
    },
  },
};
</script>